module.exports = __webpack_public_path__ + "media/flags/018-south-korea-e5b4e019.svg";